import { persons as kycAcceptance } from '#proto/index.qonto.kycb.acceptance';
import type { firstparty as kycVerification } from '#proto/index.qonto.kycb.api.kyc_verification';
import { verification as identityVerification } from '#proto/index.qonto.identity_verification';
import type { ApiCreateFourthlineProcessResponse } from '#proto/index.qonto.kycb.api.identities.firstparty.v1';
import type {
  ApiCreateKYCResponse,
  ApiKYCStatus as ApiCreateKYCStatus,
} from '#proto/qonto/registration/kyc/firstparty/v2/create_kyc';

export type KycResponse = kycAcceptance.firstparty.v1.ApiGetPersonAcceptanceResponse;
export type ApiCreateProcessResponse = kycAcceptance.firstparty.v1.ApiCreateProcessResponse;
export type FourthlineProviderDetails = kycAcceptance.firstparty.v1.ApiFourthlineProviderDetails;
export type IdnowProviderDetails = kycAcceptance.firstparty.v1.ApiIdnowProviderDetails;
export const KycCurrentStatus = kycAcceptance.firstparty.v1.ApiKycCurrentStatus;
export const KycProcessType = kycAcceptance.firstparty.v1.ApiProcessType;
export const KycProcessStatus = kycAcceptance.firstparty.v1.ApiProcessStatus;
export const KycProvider = kycAcceptance.firstparty.v1.ApiProvider;
export const IdnowProviderDetailsStatus = kycAcceptance.firstparty.v1.ApiIdnowProviderDetailsStatus;
export type KycActiveProcess = NonNullable<KycResponse['activeProcess']>;
export type OptionalKycActiveProcess = {
  activeProcess: Pick<KycActiveProcess, 'provider' | 'providerDetails'>;
};

export type CreateKycResponse = ApiCreateKYCResponse;
export type CreateKycStatus = ApiCreateKYCStatus;

export type FourthlineProcessResponse = ApiCreateFourthlineProcessResponse;

export interface FourthlineProcessAttributes {
  provider_token: string;
  redirect_url: string;
  is_qes_required: boolean;
}

export type SendKycSmsResponse = kycVerification.v3.ApiSendKycSmsResponseKyc;
export type SendKycSmsRequest = kycVerification.v3.ApiSendKycSmsRequestKyc;

export type KycSetupRequest = kycVerification.v3.ApiSetupKycRequest;
export type KycSetupResponse = kycVerification.v3.ApiSetupKycResponse;
export interface KycSetupAttributes {
  membership_id: string;
  verification_url: string;
  qonto_redirection_url?: string | null;
}

export type RequestCredentialsResponse =
  identityVerification.firstparty.v4.ApiRequestCredentialsResponse;
export const IdentityVerificationProvider = identityVerification.firstparty.v4.ApiProvider;
export const IdentityVerificationStatus = identityVerification.firstparty.v4.ApiStatus;

export type GetIdentityVerificationResponse =
  identityVerification.firstparty.v4.ApiGetIdentityVerificationResponse;
